import { render, staticRenderFns } from "./CadastroFormSelect.vue?vue&type=template&id=2d256b5b&scoped=true&lang=pug&"
import script from "./CadastroFormSelect.vue?vue&type=script&lang=js&"
export * from "./CadastroFormSelect.vue?vue&type=script&lang=js&"
import style0 from "./CadastroFormSelect.vue?vue&type=style&index=0&id=2d256b5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d256b5b",
  null
  
)

export default component.exports